(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('add-disease', {
            parent: 'entity',
            url: '/add-disease?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addDisease.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-disease/add-diseases.html',
                    controller: 'AddDiseaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addDisease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('add-disease-detail', {
            parent: 'entity',
            url: '/add-disease/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.addDisease.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/add-disease/add-disease-detail.html',
                    controller: 'AddDiseaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('addDisease');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AddDisease', function($stateParams, AddDisease) {
                    return AddDisease.get({id : $stateParams.id});
                }]
            }
        })
        .state('add-disease.new', {
            parent: 'add-disease',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-disease/add-disease-dialog.html',
                    controller: 'AddDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                information: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('add-disease', null, { reload: true });
                }, function() {
                    $state.go('add-disease');
                });
            }]
        })
        .state('add-disease.edit', {
            parent: 'add-disease',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-disease/add-disease-dialog.html',
                    controller: 'AddDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AddDisease', function(AddDisease) {
                            return AddDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('add-disease.delete', {
            parent: 'add-disease',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/add-disease/add-disease-delete-dialog.html',
                    controller: 'AddDiseaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AddDisease', function(AddDisease) {
                            return AddDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('add-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
